import { render } from "./ShippingAddressForm.vue?vue&type=template&id=3467f900"
import script from "./ShippingAddressForm.vue?vue&type=script&setup=true&lang=js"
export * from "./ShippingAddressForm.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/ShippingAddressForm.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3467f900"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3467f900', __exports__)) {
    api.reload('3467f900', __exports__)
  }
  
  module.hot.accept("./ShippingAddressForm.vue?vue&type=template&id=3467f900", () => {
    api.rerender('3467f900', render)
  })

}


export default __exports__